import { useEffect, useState } from "react";
import { Paginator } from "primereact/paginator";
import { translate } from "../../localization/translateService";
import KeduLoading from "../loading/KeduLoading";
import NoData from "../nodata/NoData";
import ClassItem from "./ClassItem";

const CLASS_LIST_TRANSLATION_KEYS = {
  noResultsFound: "MESSAGES.NO_RESULTS_FOUND",
  upcomingClasses: "CLASS.LABELS.UPCOMING_CLASSES",
  completedClasses: "CLASS.LABELS.COMPLETED_CLASSES",
};

const PAGINATOR_TEMPLATE = {
  layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
  FirstPageLink: (options) => (
    <button type="button" className={options.className} onClick={options.onClick} disabled={options.disabled}>
      <i className="pi pi-angle-double-left"></i>
    </button>
  ),
  PrevPageLink: (options) => (
    <button type="button" className={options.className} onClick={options.onClick} disabled={options.disabled}>
      <i className="pi pi-angle-left"></i>
    </button>
  ),
  PageLinks: (options) => (
    <button type="button" className={options.className} onClick={options.onClick}>
      {options.page + 1}
    </button>
  ),
  NextPageLink: (options) => (
    <button type="button" className={options.className} onClick={options.onClick} disabled={options.disabled}>
      <i className="pi pi-angle-right"></i>
    </button>
  ),
  LastPageLink: (options) => (
    <button type="button" className={options.className} onClick={options.onClick} disabled={options.disabled}>
      <i className="pi pi-angle-double-right"></i>
    </button>
  ),
};

const DEFAULT_ITEM_COL_CLASS = "col-12 md:col-12 lg:col-4";

export default function ClassList({ id, listData, first = 0, rows = 12, total = 0, onPageChange, onItemClick, translations, toast, itemColClassName = DEFAULT_ITEM_COL_CLASS }) {
  const [listTranslation, setListTranslation] = useState({
    noResultsFound: "",
    upcomingClasses: "",
    completedClasses: "",
  });

  useEffect(() => {
    const loadListTranslation = async () => {
      try {
        const [noResultsFound, upcomingClasses, completedClasses] = await Promise.all([
          translate(CLASS_LIST_TRANSLATION_KEYS.noResultsFound, true),
          translate(CLASS_LIST_TRANSLATION_KEYS.upcomingClasses, true),
          translate(CLASS_LIST_TRANSLATION_KEYS.completedClasses, true),
        ]);
        setListTranslation({ noResultsFound, upcomingClasses, completedClasses });
      } catch {}
    };
    loadListTranslation();
  }, []);

  if (listData === null || listData === undefined) {
    return <KeduLoading />;
  }

  if (listData.length === 0) {
    return (
      <div className="mt-8">
        <NoData message={listTranslation.noResultsFound} />
      </div>
    );
  }

  const colClass = itemColClassName || DEFAULT_ITEM_COL_CLASS;

  const upcomingItems = listData.filter((item) => item?.hasUpcomingSession);
  const completedItems = listData.filter((item) => !item?.hasUpcomingSession);

  const renderGrid = (items) => (
    <div className="grid w-full">
      {items.map((item) => (
        <div key={item?.id ?? item?.publicId ?? Math.random()} className={`${colClass} p-3`}>
          <ClassItem data={item} onClick={() => onItemClick?.(item)} translations={translations} toast={toast} />
        </div>
      ))}
    </div>
  );

  return (
    <div id={id} className="flex flex-column">
      {upcomingItems.length > 0 && (
        <div className="class-list-upcoming flex flex-column">
          {completedItems.length > 0 && (
            <h5 className="keduall-typography text-default-txt heading-h5-semibold-600 px-3 pb-2">{listTranslation.upcomingClasses}</h5>
          )}
          {renderGrid(upcomingItems)}
        </div>
      )}

      {completedItems.length > 0 && (
        <div className="class-list-completed flex flex-column mt-4">
          <h5 className="keduall-typography text-secondary-txt heading-h5-semibold-600 px-3 pb-2">{listTranslation.completedClasses}</h5>
          {renderGrid(completedItems)}
        </div>
      )}

      {total > rows && <Paginator template={PAGINATOR_TEMPLATE} first={first} rows={rows} totalRecords={total} onPageChange={onPageChange} className="keduall-paginator" />}
    </div>
  );
}
